import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
} from '../actions/AuthTypes';

const initialState = {
    isAuthenticated: false,
    user: null,
    token: '',
    auth: {
        email: '',
        idToken: '',
        localId: '',
        expiresIn: '',
        refreshToken: '',
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    console.log('Auth Reducer - Current State:', state);
    console.log('Auth Reducer - Action:', action);

    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: action.payload,
            };
            
        case LOGIN_CONFIRMED_ACTION:
            const newState = {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                token: action.payload.token,
                auth: {
                    email: action.payload.user?.email || '',
                    idToken: action.payload.token || '',
                    localId: action.payload.user?._id || '',
                    expiresIn: action.payload.user?.tokenExpiry || '',
                    refreshToken: action.payload.user?.refreshToken || '',
                },
                errorMessage: '',
                successMessage: 'Login Successful',
                showLoading: false,
            };
            console.log('Auth Reducer - New State:', newState);
            return newState;
            
        case LOGIN_FAILED_ACTION:
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                token: '',
                auth: {
                    email: '',
                    idToken: '',
                    localId: '',
                    expiresIn: '',
                    refreshToken: '',
                },
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
            
        case LOGOUT_ACTION:
            return initialState;
            
        default:
            return state;
    }
}

    
